import { LagerauswertungAlle } from "@/components/lagerauswertung/lagerauswertung";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/lagerauswertung/alle/$date")({
  component: RouteComponent,
});

function RouteComponent() {
  const { date } = Route.useParams();
  const navigate = useNavigate();
  const changeDate = (date: string) => {
    navigate({
      to: "/lagerauswertung/alle/$date",
      params: { date },
    });
  };
  return <LagerauswertungAlle date={date} changeDate={changeDate} />;
}
